module.exports = __webpack_public_path__ + "img/ahk-nigeria-logo.62ef1250.png";